export { SORT_TYPES } from './sortTypes';

export const SALES_TAX_COLUMNS = [
  { id: 'tax_name', label: 'Tax', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'rate', label: 'Rate', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'general_ledger_code', label: 'GL Code', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'collected', label: 'Collected', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
];

export const buildSalesTaxColumns = (generalLedgerCodesEnabled) =>
  SALES_TAX_COLUMNS.filter(c => c.id !== 'general_ledger_code' || generalLedgerCodesEnabled);

export const getDefaultVisibleColumns = (generalLedgerCodesEnabled) =>
  buildSalesTaxColumns(generalLedgerCodesEnabled).filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = (generalLedgerCodesEnabled) =>
  buildSalesTaxColumns(generalLedgerCodesEnabled).filter(c => !c.defaultVisible && !c.alwaysVisible);
